export interface Feature {
  /**
   * Description used in help output
   */
  description: string;

  /**
   * Whether the feature is enabled by default
   * @default false
   */
  default?: boolean;
}
